export const ME_MODAL_COMPONENT_TYPE = {
  EDIT_MODAL: 'editmodal',
  VIEW_MODAL: 'viewmodal'
};
